import React, {
  useCallback,
  useReducer,
  useEffect,
  useContext,
  useState,
  useRef,
} from "react";
import {
  View,
  ScrollView,
  Dimensions,
  FlatList,
  Pressable,
  SectionList,
  Keyboard,
  TouchableOpacity,
} from "react-native";
import SearchManager from "@presto-services/features/search/SearchManager";
import FavoritesManager from "@presto-services/features/favorites/FavoritesManager";
import I18n from "i18n-js";
import SearchableScreen from "../SearchableScreen/SearchableScreen";
import DealsComponent from "@presto-screen-components/DealsComponent/DealsComponent";
import useFocusEffect from "@presto-common/useFocusEffect";
import _ from "lodash";
import ItemCard from "@presto-screen-components/ItemCard/ItemCard";
import { VerticalSpacing } from "@presto-components/Spacing";
import NavigatorContext from "@presto-contexts/NavigatorContext";
import utils from "../../utils";
import PrestoText from "@presto-components/PrestoText";
import ThemeContext from "@presto-contexts/ThemeContext";
import { useCatalog } from "@presto-stores/CatalogStore";
import GradientBackgroundForHeader from "@presto-screen-components/SearchableScreen/GradientBackgroundForHeader";
import UserContext from "@presto-contexts/UserContext";
import AnalyticsManager from "../../common/AnalyticsManager";
import { RowButton } from "@presto-components/PrestoButton";
import { LineDivider } from "@presto-components/Dividers/Dividers";

export function reducer(state, { payload, type }) {
  switch (type) {
    case "SET_FAVORITES":
      return { ...state, favorites: payload };
    case "SET_FILTER_FAVORITES":
      return { ...state, filteredFavorites: payload };
    case "SET_CATEGORY_ITEM":
      return { ...state, items: { ...state.items, [payload.id]: payload } };
    case "SET_CATEGORY_ITEMS":
      return { ...state, items: payload };
    case "SET_FILTERED_ITEMS":
      return { ...state, filteredItems: payload };
    case "SET_DISTRIBUTORS":
      return { ...state, distributors: payload };
    case "SET_SELECTED_DISTRIBUTORS":
      return { ...state, selectedDistributor: payload };
    case "SET_OFFERS":
      return { ...state, onOffer: payload };
    case "SET_OFFERS":
      return { ...state, onOffer: payload };
    case "SET_STOCK":
      return { ...state, inStock: payload };
    case "SET_SORT_TYPE":
      return {
        ...state,
        sort_type: payload,
      };
    case "SET_FOCUS":
      return {
        ...state,
        focus: payload,
      };
    case "SET_SUGGESTION":
      return {
        ...state,
        suggestion: payload,
      };
    case "SET_SEARCH_QUERY":
      return {
        ...state,
        query: payload,
      };
  }
  return state;
}

const windowHeight = Dimensions.get("window").height;

export default function FavoritesSccreen() {
  const { Navigator } = useContext(NavigatorContext);
  const { theme } = useContext(ThemeContext);
  const catalog = useCatalog((state) => state.catalog);
  const { user } = useContext(UserContext);
  const [state, dispatch] = useReducer(reducer, {
    favorites: [],
    inStock: null,
    items: [],
    distributors: null,
    selectedDistributor: "",
    filteredItems: null,
    onOffer: null,
    sort_type: "listing",
    focus: false,
    suggestion: [],
    query: "",
  });

  const {
    favorites,
    items,
    distributors,
    selectedDistributor,
    filteredItems,
    onOffer,
    sort_type,
    focus,
    suggestion,
    query,
    inStock,
  } = state;

  const getItems = () => {
    const ids = _.map(state.favorites, (fav) => fav.item_id);
    if (!_.isEmpty(ids)) {
      SearchManager.fuzzySearchCategoryItem(
        { ids: ids, size: 100 },
        (response) => {
          const items = _.map(response.hits.hits, (item) => item._source);
          const filteredItems = _.filter(
            items,
            (item) =>
              item.other_data.is_gift != "true" || !item.other_data.is_gift
          );
          dispatch({
            type: "SET_CATEGORY_ITEMS",
            payload: _.keyBy(filteredItems, "id"),
          });
        },
        (error) => {
          alert(I18n.t("screen_messages.error_loading_favorites"));
        }
      );
    }
  };

  const FilterDistributor = () => {
    if (favorites?.length !== 0 && items?.length !== 0) {
      const mySet = new Set();
      let tempArrayWithDistributor = favorites.map((ele) => {
        return items[ele.item_id];
      });
      tempArrayWithDistributor?.forEach((element) => {
        if (element?.other_data?.company_name !== null) {
          mySet?.add(element?.other_data?.company_name);
        }
      });
      const filteredDistributors = distributors.filter((distributor) =>
        mySet.has(distributor.key)
      );
      dispatch({
        type: "SET_DISTRIBUTORS",
        payload: filteredDistributors,
      });
    }
  };

  useEffect(() => {
    FilterDistributor();
  }, [items, sort_type]);

  useEffect(() => {
    var result = null;
    if (selectedDistributor != "") {
      result = _.pickBy(
        items,
        (item) => item?.other_data?.company_name === selectedDistributor
      );
    }
    if (onOffer !== null) {
      let tempResult = result !== null ? result : items;
      if (onOffer) {
        result = _.pickBy(tempResult, (item) => item?.variations?.length > 0);
      } else {
        result = _.pickBy(tempResult, (item) => item?.variations?.length == 0);
      }
    }
    if (inStock !== null) {
      let tempResult = result !== null ? result : items;
      if (inStock) {
        result = _.pickBy(tempResult, (item) => item.sold_out == false);
      }
    }
    dispatch({
      type: "SET_FILTERED_ITEMS",
      payload: result,
    });
  }, [selectedDistributor, onOffer, inStock]);

  useEffect(() => {
    if (sort_type !== "listing") {
      let sortedResult = favorites.map((ele) => {
        return { ...items[ele.item_id], item_id: ele.item_id };
      });
      if (sort_type === "price_low") {
        sortedResult = _.sortBy(sortedResult, ["price.base_price"]);
      } else if (sort_type === "price_high") {
        sortedResult = _.orderBy(sortedResult, ["price.base_price"], ["desc"]);
      } else if (sort_type === "name_desc") {
        sortedResult = _.orderBy(sortedResult, ["name"], ["desc"]);
      } else if (sort_type === "name_asc") {
        sortedResult = _.orderBy(sortedResult, ["name"]);
      }
      dispatch({
        type: "SET_FAVORITES",
        payload: sortedResult,
      });
    }
  }, [sort_type, selectedDistributor, onOffer, inStock]);

  useEffect(() => {
    if (state.favorites && sort_type === "listing") {
      getItems();
    }
  }, [state.favorites]);

  const [clearFlag, setClearFlag] = useState(false);

  useFocusEffect(
    useCallback(() => {
      if (sort_type === "listing") {
        FavoritesManager.getFavoriteProducts(
          { params: { records_per_page: 100, page: 1 } },
          (response) => {
            dispatch({
              type: "SET_FAVORITES",
              payload: response.data,
            });
          },
          (error) => {
            utils.errorMessage(error);
          }
        );
      }
    }, [sort_type, clearFlag])
  );

  useEffect(() => {
    if (sort_type === "listing") {
      SearchManager.getZipHealthFilteredOtherDataAttributes(
        {},
        "company_name",
        (response) => {
          dispatch({
            type: "SET_DISTRIBUTORS",
            payload: response.aggregations.distinct_company_name.buckets,
          });
        },
        (error) => {}
      );
    }
  }, []);

  const onPressDistributorsName = (key) => {
    AnalyticsManager.send("my_products_distributors");
    if (selectedDistributor === key) {
      dispatch({
        type: "SET_SELECTED_DISTRIBUTORS",
        payload: "",
      });
    } else {
      dispatch({
        type: "SET_SELECTED_DISTRIBUTORS",
        payload: key,
      });
    }
  };

  const renderDistributors = ({ item, index }) => {
    return (
      <Pressable
        onPress={() => onPressDistributorsName(item?.key)}
        key={index}
        style={{
          flex: 1,
          height: 35,
          maxWidth: 200,
          backgroundColor:
            item.key === selectedDistributor ? theme.primary : theme.white,
          borderColor: "#CBE5D3",
          borderWidth: 1,
          borderRadius: 8,
          marginRight: 10,
          padding: 10,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <PrestoText
          fontStyle="500.medium"
          size={12}
          numberOfLines={1}
          color={
            item.key === selectedDistributor ? theme.white : theme.paragraph
          }
        >
          {item?.key}
        </PrestoText>
      </Pressable>
    );
  };

  const rearrangeFavourites = () => {
    let mergedFavourite = [];
    var tempItems = filteredItems ? filteredItems : items;
    if (state.favorites) {
      const favSoldout = _.filter(
        state?.favorites,
        (fav) => _.find(tempItems, { id: fav.item_id })?.sold_out === true
      );
      const favUnsoldout = _.filter(
        state?.favorites,
        (fav) => _.find(tempItems, { id: fav.item_id })?.sold_out === false
      );
      mergedFavourite = [...favUnsoldout, ...favSoldout];
    }
    return mergedFavourite;
  };

  const renderFavorite = (fav) => {
    var item = filteredItems ? filteredItems[fav.item_id] : items[fav.item_id];
    if (item) {
      return <ItemCard key={fav.id} item={item} />;
    } else {
      return null;
    }
  };

  const onFilterChanged = (params) => {
    dispatch({
      type: "SET_SELECTED_DISTRIBUTORS",
      payload: params?.company_name,
    });
    dispatch({
      type: "SET_OFFERS",
      payload: params?.on_offer,
    });
    dispatch({
      type: "SET_STOCK",
      payload: params?.in_stock,
    });
    dispatch({
      type: "SET_SEARCH_QUERY",
      payload: "",
    });
  };

  const onSortChanged = (key) => {
    dispatch({
      type: "SET_SORT_TYPE",
      payload: key,
    });
  };

  const onFilter = () => {
    AnalyticsManager.send("filter_items");
    dispatch({
      type: "SET_SORT_TYPE",
      payload: "listing",
    });
    Navigator.emit({
      event: "modal",
      params: {
        screenName: "FILTER_OPTIONS_SCREEN",
        screenParams: {
          onFilterChange: onFilterChanged,
          allManufacturer: distributors,
          selectedManufacturer: selectedDistributor,
          onOffer: onOffer,
          selectedPrice: state.price_range,
          showPrice: false,
          inStock: inStock,
          showClear: true,
        },
      },
    });
  };

  const onSort = () => {
    AnalyticsManager.send("sort_items");
    Navigator.emit({
      event: "modal",
      params: {
        screenName: "SORT_OPTIONS_SCREEN",
        screenParams: {
          onSortChanged: onSortChanged,
          selectedSort: state.sort_type,
        },
      },
    });
  };

  const onSearchItemPress = (query) => {
    onSearch(_.toLower(query));
  };
  const onSearch = (text) => {
    if (!_.isEmpty(text)) {
      const result = _.pickBy(items, (item) =>
        item?.name?.toLowerCase().includes(text.toLowerCase())
      );
      dispatch({
        type: "SET_FILTERED_ITEMS",
        payload: result,
      });
      dispatch({
        type: "SET_SUGGESTION",
        payload: [],
      });
      dispatch({
        type: "SET_FOCUS",
        payload: false,
      });
    }
  };

  const renderAutoCompleteItem = ({ item, index }) => {
    return (
      <View key={`index-${index}-query`}>
        <RowButton
          title={item?.name}
          rightTitle={""}
          onPress={() => {
            onSearchItemPress(item?.name);
            Keyboard.dismiss();
            dispatch({
              type: "SET_SUGGESTION",
              payload: [],
            });
          }}
          showDisclosure={false}
        />
        <LineDivider dividerColor="#DADADA" width="100%" theme={theme} />
      </View>
    );
  };

  const renderAutoComplete = () => {
    return (
      <View
        style={{
          backgroundColor: "transparent",
          position: "absolute",
          height: 300,
          top: 10,
          left: 0,
          width: "100%",
          flexDirection: "column",
          alignItems: "center",
          zIndex: 100,
        }}
      >
        <View
          style={{
            backgroundColor: "white",
            position: "absolute",
            height: "100%",
            width: "95%",
            borderRadius: 10,
            borderWidth: 1,
            borderColor: "lightgray",
          }}
        >
          <FlatList
            keyExtractor={(_, index) => "index-" + index}
            data={suggestion}
            renderItem={renderAutoCompleteItem}
            layout={"default"}
            showsHorizontalScrollIndicator={false}
            keyboardShouldPersistTaps="handled"
          />
        </View>
      </View>
    );
  };

  const renderSearchItem = ({ item: query, index }) => {
    return <View></View>;
  };

  const renderSectionHeader = ({ section }) => {
    return <View></View>;
  };

  const renderEmptySearchPage = () => {
    const sections = [];
    return (
      <SectionList
        keyExtractor={(_, index) => "index-" + index}
        stickySectionHeadersEnabled={false}
        renderSectionHeader={renderSectionHeader}
        sections={sections}
        renderItem={renderSearchItem}
        layout={"default"}
        showsHorizontalScrollIndicator={false}
      />
    );
  };

  const onSearchFocus = () => {
    AnalyticsManager.send("my_products_search");
    dispatch({
      type: "SET_FOCUS",
      payload: true,
    });
  };

  const loadAutoComplete2 = (text) => {
    if (text.trim() === "") {
      dispatch({
        type: "SET_SUGGESTION",
        payload: [],
      });
    } else {
      const results = favorites?.filter((item) =>
        item?.name?.toLowerCase().includes(text.toLowerCase())
      );
      dispatch({
        type: "SET_SUGGESTION",
        payload: results,
      });
    }
  };

  const onSearchChange = (text) => {
    dispatch({
      type: "SET_SEARCH_QUERY",
      payload: text,
    });
    loadAutoComplete2(text);
  };

  const onBack = () => {
    dispatch({
      type: "SET_FOCUS",
      payload: false,
    });
    dispatch({
      type: "SET_SUGGESTION",
      payload: [],
    });
    dispatch({
      type: "SET_SEARCH_QUERY",
      payload: "",
    });
  };
  const searchInputRef = useRef();
  useEffect(() => {
    if (focus) {
      setTimeout(() => searchInputRef.current?.focus(), 100);
    }
  }, [focus]);

  const handleSearchClear = () => {
    dispatch({
      type: "SET_SELECTED_DISTRIBUTORS",
      payload: "",
    });
    dispatch({
      type: "SET_OFFERS",
      payload: null,
    });
    dispatch({
      type: "SET_STOCK",
      payload: null,
    });
    dispatch({
      type: "SET_SEARCH_QUERY",
      payload: "",
    });
    dispatch({
      type: "SET_FILTERED_ITEMS",
      payload: null,
    });
    dispatch({
      type: "SET_SORT_TYPE",
      payload: "listing",
    });
    setClearFlag(!clearFlag);
  };

  return (
    <SearchableScreen
      onFocus={onSearchFocus}
      showSoftInputOnFocus={false}
      showOptions={focus == false ? true : false}
      onFilter={onFilter}
      onSort={onSort}
      onSearch={onSearch}
      onSearchChange={onSearchChange}
      showBackIcon={focus}
      canGoback={true}
      onBack={onBack}
      placeholder={I18n.t(
        "screen_messages.common.search_by_placeholder_options.category"
      )}
      inputref={searchInputRef}
      searchContainerStyle={{
        ...(utils.isDesktop() && {
          paddingTop: 0,
        }),
      }}
    >
      {/* {utils.isDesktop() ? (
        <View style={{ minHeight: 50 }}>
          <GradientBackgroundForHeader user={user} />
        </View>
      ) : null} */}

      {suggestion?.length > 0 && query?.length >= 3
        ? renderAutoComplete()
        : null}

      <ScrollView
        style={{ height: windowHeight - 100 }}
        contentContainerStyle={{ paddingBottom: 100 }}
      >
        {focus ? (
          renderEmptySearchPage()
        ) : (
          <View>
            {query !== "" ? (
              <View
                style={{
                  paddingHorizontal: theme.containerPadding,
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: 10,
                }}
              >
                <PrestoText
                  fontStyle="semibold"
                  size={14}
                  color={theme.primary}
                >
                  {filteredItems && Object?.keys(filteredItems)?.length == 0
                    ? I18n.t("screen_messages.common.no_search_results_for", {
                        query: query,
                      })
                    : I18n.t("screen_messages.common.search_results_for", {
                        query: query,
                      })}
                </PrestoText>
                <TouchableOpacity onPress={handleSearchClear}>
                  <PrestoText
                    fontStyle={"semibold"}
                    color={theme.primary}
                    size={16}
                    extraStyle={{ textDecorationLine: "underline" }}
                  >
                    {I18n.t("screen_messages.clear")}
                  </PrestoText>
                </TouchableOpacity>
              </View>
            ) : null}

            {items?.length > 0 && favorites.length > 0 ? (
              <View
                style={{
                  paddingLeft: 20,
                }}
              >
                <PrestoText size={theme.h6FontSize} color={theme.paragraph}>
                  {I18n.t("screen_messages.products.your_products")}
                </PrestoText>
              </View>
            ) : null}
            {_.map(rearrangeFavourites(), (fav) => {
              return renderFavorite(fav);
            })}
          </View>
        )}
      </ScrollView>
    </SearchableScreen>
  );
}
